export default {
  "app_name": import.meta.env.VITE_APP_SITE_NAME,
  "shopping_agent": "購物代理",
  "forwarding": "轉運",
  "services": "服務",
  "about": "關於我們",
  "expert_buy": "專家代購",
  "shipping_calculator": "運費計算機",
  "customer_review": "客戶評論",
  "dropshipping": "一件代發",
  "business_service": "商業服務",
  "trusted_seller": "信譽賣家",
  "blog": "部落格",
  "user_guides": "用戶指南",
  "terms_of_service": "服務條款",
  "terms_of_shipping": "運輸條款",
  "privacy_policy": "隱私政策",
  "faq": "常見問題",
  "home": "首頁",
  "notice": "通知",
  "cart": "購物車",
  "me": "我的",
  "service_menu": "服務選單",
  "account": "帳戶",
  "user_center": "用戶中心",
  "my_order": "我的訂單",
  "my_store": "我的商店",
  "log_out": "登出",
  "sign_in": "登入",
  "sign_up": "註冊",
  "compensation_taxation": "賠償與稅收",
  "tok_forum": "論壇",
  "get_community_help": "加入我們的論壇",
  "community_des": "加入我們的論壇以獲取幫助並幫助他人",
  "page_home": {
    "title": "您的終極目的地",
    "description": "中國購物代理",
    "search_product_text": "商品URL",
    "timeline": [
      {
        "title": "下訂單",
        "subtitle": "選擇與購買"
      },
      {
        "title": "提交包裹",
        "subtitle": "品質控制與國際運輸"
      },
      {
        "title": "收貨",
        "subtitle": "接收與分享"
      }
    ],
    "cards": [
      ["註冊", "並獲得350美元優惠券！"],
      ["新手", "指南"],
      ["加入我們", "在Reddit和Discord上"]
    ],
    "shop_chinese": {
      "title": "在中國電商網站購物",
      "cards": [
        {
          "title": "下達您的訂單",
          "description": "輕鬆享受從中國線上或線下購買任何產品的無憂購物體驗。要下訂單，只需粘貼產品連結即可。輕鬆享受我們從尋找到購買的全方位服務。"
        },
        {
          "title": "運送至NiuniuBox倉庫",
          "description": "透過我們的服務從不同賣家處購買，我們將高效地整合您的購物。所有物品都將運送到中國的NiuniuBox倉庫，為您簡化流程。"
        },
        {
          "title": "品質控制",
          "description": "您的產品到達NiuniuBox倉庫後，會經過嚴格的品質控制。我們的團隊會仔細檢查每件商品是否有缺陷，並確保尺寸、顏色等符合要求。有NiuniuBox，您可以放心，因為我們有專門的售後服務。"
        },
        {
          "title": "國際運輸",
          "description": "從您的倉庫庫存中選擇產品，並輕鬆地將它們合併為一個包裹。憑藉NiuniuBox可靠的國際運輸服務，您的購物將直接送到您家門口。享受世界級運輸服務的便利。"
        }
      ]
    },
    "bottom": [
      {
        "title": "豐富的商品",
        "description": "我們為您尋找來自中國的各種經濟實惠的產品"
      },
      {
        "title": "降低成本",
        "description": "來自不同賣家的產品只需一次運費，全部合併為一個包裹"
      },
      {
        "title": "優質服務",
        "description": "我們重視您的忠誠度，並致力於提供卓越的服務和支持"
      },
      {
        "title": "快速回應",
        "description": "保證回答您所有關於我們服務的問題"
      }
    ],
    "migration": {
      "title": "重要公告",
      "dear_users": "尊敬的用户：",
      "announce_before_link": "我们很高兴地宣布，Niuniubox 已正式更名为 Pikobuy ",
      "link_label": "www.pikobuy.com",
      "closing": "在新的品牌名称下，我们将继续为您提供竭诚服务。",
      "got_it": "知道了"
    }
  },
  "page_shopping": {
    "shopping_des": "從中國購買",
    "shopping_step": "1.尋找和搜索產品 2.支付商品費用 3.我們為您購買 4.支付運費 5.我们為您發貨",
    "category": "分類",
    "load_more_items": "加載更多商品",
    "note": "免責聲明：我們網站上顯示的所有可供代購服務的產品均來自第三方購物平台，並非由我們直接銷售。因此，對於因侵犯知識產權或商品版權而引起的問題，我們不承擔任何責任。",
    "bottom_text": "作為專業的淘寶代理，我們幫助您以極低的價格從中國最大的購物網站購買大量產品。我們是您在淘寶網、1688.com上尋找、購買、檢查和運送商品的淘寶代理。我們的報價包括中國採購、購買和國際運輸。我們為從中國到所有國家的國際運輸提供最大的折扣，包括美國、加拿大、英國、澳大利亞、法國、新加坡、墨西哥、巴西、智利等。無論您身在何處，我們都將包裹直接送到您家門口。我們為所有貨物提供在線追踪信息。我們有專業的客戶服務經理幫助您成功購買和運輸。",
    "process_data": "處理數據",
    "process_des": "您可以了解您訂單的一切。每當您擔心時，我們都有數據告訴您一切。"
  },
  "meta": {
    "index_title": "淘寶代理 | 天貓代理 | 1688代理 | 英文淘寶 | 購物代理 | 中國轉運",
    "index_des": "我們是一個中國購物代理平台。我們幫助客戶在淘寶上購買產品。從中國購買您喜愛的商品從未如此方便和容易。",
    "shopping_agent_title": "購物代理",
    "shopping_agent_des": "通過購物代理購買中國產品。淘寶代理、1688代理、微店代理、Yupoo代理。",
    "forwarding_title": "運輸代理 - 從中國運送您的包裹",
    "forwarding_des": "專業的全球轉運平台，擁有轉運倉庫，並為美國、英國、加拿大、德國、澳大利亞、新加坡、墨西哥等國家提供專業的物流服務，全球運輸",
    "expert_buy_title": "專家代購",
    "expert_buy_des": "通過淘寶代理購買產品，從中國進口。最低的運費價格。無服務費。",
    "calculator_title": "國際物流費用估算",
    "calculator_des": "我們幫助您估算全球物流成本。經濟實惠的物流服務。更快的物流服務。",
    "trusted_seller_title": "信譽賣家",
    "trusted_seller_des": "信譽賣家：從這些賣家處購買，然後我們為您發貨。淘寶賣家，微店賣家。"
  },
  "my_parcel": {
    "internationalParcels": "國際包裹",
    "trackYourInternationalShipments": "追踪您的國際貨運並設置運輸偏好",
    "pleaseSelect": "請選擇",
    "yourRemark": "您的備註",
    "startDate": "開始日期",
    "endDate": "結束日期",
    "alertTrackParcels": "在此追踪您的包裹。狀態為「準備配置運送」的包裹已經打包和測量，準備配置運送。",
    "noPackagesToShip": "您沒有要運送的包裹",
    "parcel": "包裹",
    "parcelID": "包裹ID：",
    "shippingLabel": "運費：",
    "pending": "待處理",
    "finalFee": "最終費用：",
    "discount": "折扣：",
    "coupon": "優惠券：",
    "created": "創建於：",
    "status": "狀態",
    "shippingMethod": "運輸方式",
    "notConfiguredYet": "尚未配置",
    "products": "個商品",
    "measured": "已測量",
    "estimated": "預估",
    "dimensions": "尺寸：",
    "weightInformation": "重量信息",
    "billingWeight": "計費重量：",
    "na": "不適用",
    "actual": "實際：",
    "volume": "體積：",
    "action": "操作",
    "configureShippingMethod": "運輸方式",
    "payShipping": "支付運費",
    "track": "追踪",
    "address": "地址",
    "shipping": "運送：",
    "configure": "配置",
    "pay": "支付",
    "viewMoreProducts": "查看此包裹中的更多產品",
    "orderID": "訂單ID：",
    "quantity": "數量：",
    "times": "x",
    "addressLabel": "地址",
    "yourRemarkTitle": "您的備註",
    "parcelRemarkTitle": "包裹備註",
    "noRemarks": "此包裹沒有備註",
    "parcelImages": "包裹圖片",
    "failedToLoad": "加載失敗",
    "noImages": "此包裹沒有可用圖片",
    "productsInParcel": "包裹中的產品",
    "type": "類型：",
    "noProducts": "此包裹沒有產品詳情",
    "configureShipping": "配置運送",
    "alertPackagePrepared": "您的包裹已準備好。現在請選擇您的運輸方式並提供您的送貨地址。",
    "packageDetails": "包裹詳情",
    "readyForShipping": "準備運送",
    "actualWeight": "實際重量：",
    "actualDimensions": "實際尺寸：",
    "packagingNotes": "包裝說明：",
    "step1SubmitAddress": "步驟1：提交地址",
    "select": "選擇",
    "recipientName": "收件人姓名",
    "email": "電子郵件",
    "phoneNumber": "電話號碼",
    "country": "國家",
    "city": "城市",
    "stateProvince": "州/省",
    "zipCode": "郵政編碼",
    "selectShippingMethod": "選擇運輸方式",
    "selectCountryFirst": "請先選擇國家",
    "selectedShippingMethod": "已選運輸方式",
    "estimatedDelivery": "預計送達時間",
    "estimatedFee": "預計費用：",
    "changeShippingMethod": "更改運輸方式",
    "remark": "備註",
    "shippingRemarkPlaceholder": "CPF / CNPJ / 稅務ID / 運輸備註",
    "saveAddress": "保存地址",
    "saveAddressHint": "將此地址保存到您的地址簿以備將來使用",
    "submitShippingConfiguration": "提交運送配置",
    "parcelDetailsTitle": "包裹詳情",
    "statusSection": "狀態",
    "actions": "操作",
    "parcelDetails": "包裹詳情",
    "trackingInfo": "追踪信息",
    "addressInfo": "地址信息",
    "costDetails": "費用詳情",
    "costPending": "待處理",
    "shippingMethodNotConfigured": "未配置運輸方式",
    "packageDimensions": "包裹尺寸",
    "measuredDimensions": "測量尺寸",
    "estimatedDimensions": "預估尺寸",
    "length": "長度：",
    "width": "寬度：",
    "height": "高度：",
    "totalVolume": "總體積：",
    "volumetricWeight": "體積重量：",
    "weightCalculation": "重量計算",
    "weightCalcVolumeUsed": "使用體積重量（較大者）",
    "weightCalcActualUsed": "使用實際重量（較大者）",
    "billingWeightTooltip": "這是用於計費的重量（實際重量和體積重量中的較大者）",
    "remarks": "備註",
    "delivery_number": "包裹ID"
  },
  "footer": {
    "supportTitle": "支援",
    "support": ["關於我們", "聯繫我們", "服務費率", "運費"],
    "servicesTitle": "服務",
    "services": ["淘寶代購", "Yupoo代理", "微店代理", "產品採購"],
    "tutorialTitle": "教程",
    "tutorial": ["購物指南", "我們的部落格", "運費"],
    "resourcesTitle": "資源",
    "resources": ["運輸政策", "退款與退貨", "隱私政策", "服務條款"],
    "followTitle": "關注我們",
    "follow": ["Youtube", "TikTok", "Facebook", "Quora", "Twitter"],
    "copyright": "© 2025 NiuNiuBox - 香港牛牛盒科技有限公司",
    "paymentMethods": ["PayPal", "American Express", "Discover", "JCB", "Mastercard", "VISA"]
  },
  "sidebar_titles": ["用戶個人資料", "訂單與配送", "財務", "帳戶"],
  "sidebar": ["帳戶", "訂單", "倉庫", "排練", "包裹", "地址", "取消", "歷史記錄", "餘額", "訊息", "優惠券", "設定", "聯盟"],
  "page_order_history": {
    "title": "訂單歷史",
    "search": {
      "order_number_placeholder": "訂單號碼",
      "product_name_placeholder": "產品名稱",
      "remark_placeholder": "備註",
      "style_sku_placeholder": "款式/SKU",
      "start_date_placeholder": "開始日期",
      "end_date_placeholder": "結束日期",
      "status_placeholder": "請選擇"
    },
    "buttons": {
      "search": "搜索",
      "pay_shopping_orders": "支付購物訂單",
      "pay_order": "支付訂單",
      "view_order": "查看訂單",
      "item_photos": "商品照片",
      "view_product": "查看產品"
    },
    "table": {
      "empty_text": "您還沒有任何訂單。",
      "header": {
        "image": "圖片",
        "details": "詳情",
        "product": "產品",
        "action": "操作"
      },
      "body": {
        "order": "訂單：",
        "total": "總計：",
        "type": "類型：",
        "status": "狀態：",
        "time": "日期：",
        "style": "款式：",
        "quantity": "數量：",
        "remark": "備註：",
        "name": "名稱："
      }
    },
    "qc_dialog": {
      "title": "品質控制照片",
      "notice": "從八月起，我們將不再提供QC照片服務。",
      "empty_description": "您的商品尚未到達我們的倉庫。"
    }
  },
  "navbar": {
    "items": ["運費估算", "聯盟", "聯繫我們", "指南"],
    "cart": "購物車",
    "login": "登入",
    "register": "註冊",
    "logout": "登出",
    "no": "否",
    "logout_confirm": "您確定要登出嗎？",
    "search": "搜索",
    "searchPlaceholder": "商品URL",
    "dropdown": ["用戶中心", "訊息", "訂單", "在倉庫", "我的排練", "我的包裹", "取消訂單", "登出"],
    "me": "我的",
    "home": "首頁",
    "menu": "選單",
    "notice": "通知"
  },
  "page_my_order": {
    "product_pic": "產品照片",
    "product_qc": "QC照片",
    "store_order_no": "商店訂單號",
    "type": "類型",
    "details": "查看",
    "remark": "備註",
    "process": "處理中",
    "cn_track": "中國國內追踪",
    "pay_order": "支付訂單",
    "search": "搜索"
  },
  "page_calculator": {
    "des": "計算全球運費",
    "item_category": "商品類別",
    "product_weight": "重量",
    "product_length": "長度",
    "product_width": "寬度",
    "product_height": "高度",
    "check": "立即檢查",
    "cost_note": "注意：UPS/DHL/FedEx的包裹重量不得低於2.5公斤。否則，只能通過小包裹專線發送",
    "about_service": "我們的運費計算器是我們網站上提供的一項附加功能，作為我們購物代理和國際快遞服務的一部分。使用我們的運費計算器，您可以根據您的產品或包裹的尺寸以及您的目的地國家估算大致的運費。您還可以使用我們的計算器查詢到您目的地國家的不同運輸公司，以及它們的預計運輸時間。",
    "service_title": "關於計算器",
    "common_goods": "普通商品",
    "brand_goods": "品牌商品",
    "liquid_goods": "液體商品",
    "battery_goods": "含電池商品",
    "shipping_method": "運輸方式",
    "delivery_time": "送達時間",
    "warehouse": "倉庫",
    "estimated_cost": "預估費用",
    "method": "方式"
  },
  "page_message": {
    "title": "訊息",
    "des": "您需要注意這部分的新聞，因為我們會給您發送訊息或電子郵件。"
  },
  "page_cart": {
    "title": "我的購物車",
    "item": "項目",
    "product": "產品",
    "price": "價格",
    "quantity": "數量",
    "freight": "運費",
    "total": "總計",
    "info": "資訊",
    "operate": "操作",
    "pay_now": "結帳",
    "confirm_buy": "確認購買？",
    "yes": "是",
    "no": "否"
  },
  "page_settlement": {
    "title": "確認您的訂單",
    "information": "注意",
    "note_line1": "1. 免費為產品拍照",
    "note_line2": "2. 支付金額包括商品成本、支付處理費和服務費",
    "note_line3": "3. 我們將通過電子郵件通知您訂單進度。請及時查看",
    "note_line4": "4. 當您的包裹到達倉庫時，您需要支付運費",
    "note_line5": "5. 每次支付您需要支付額外費用（PayPal）"
  },
  "page_shopping_payment": {
    "title": "首次支付產品費用",
    "des": "注意：此頁面只能支付產品費用。運費在#國際包裹#頁面支付。",
    "total": "總計",
    "order_no": "訂單",
    "pay_now": "前往支付",
    "shopping_notice": "重要通知："
  },
  "page_person": {
    "account": "帳戶",
    "user_center": "用戶中心",
    "wallet": "錢包",
    "orders": "訂單",
    "my_order": "我的訂單",
    "my_warehouse": "在倉庫",
    "my_parcel": "國際包裹",
    "address_book": "地址簿",
    "online_store": "網上商店",
    "my_store": "我的商店",
    "activity": "活動",
    "invite": "邀請",
    "coupons": "優惠券"
  },
  "page_seller": {
    "title": "信譽賣家",
    "buy_hanfu_title": "從這些賣家處購買漢服，然後我們運送您的包裹",
    "buy_sneaker_title": "從這些賣家處購買運動鞋，然後我們運送您的包裹",

    "buy_cosplay_title": "從這些賣家處購買cosplay產品，然後我們運送您的包裹",
    "step_line1": "1. 從這些賣家處尋找產品",
    "step_line2": "2. 提交購物訂單",
    "step_line3": "3. 我們為您發貨"
  },
  "page_profile": {
    "account": "帳戶",
    "email": "電子郵件",
    "balance": "餘額"
  },
  "page_wallet": {
    "top_up": "儲值",
    "underpaid": "未付足",
    "balance_details": "餘額詳情",
    "time": "時間",
    "empty": "無記錄",
    "amount": "金額",
    "status": "狀態",
    "info": "資訊",
    "pay": "支付",
    "paid": "已支付",
    "confirm": "確認",
    "discount_info": "折扣資訊",
    "and_get": "並獲得",
    "get_extra": "額外"
  },
  "in_warehouse": {
    "packages_in_warehouse": "倉庫中的包裹",
    "product_name": "產品名稱",
    "please_select": "請選擇",
    "remark": "備註",
    "style_sku": "款式/SKU",
    "start_date": "開始日期",
    "end_date": "結束日期",
    "reset_selections": "重置選擇",
    "select_products_alert": "選擇要一起打包的產品。打包後，您將收到通知，並可以在「我的包裹」頁面中選擇運輸選項。",
    "estimated_weight": "預估重量：{weight} KG",
    "rehearse_parcel": "包裹排練",
    "request_packaging": "請求打包",
    "orders_not_arrived_alert": "您有 {count} 個訂單尚未到達倉庫。請確認您是現在打包還是等待所有物品。",
    "table_empty_text": "此頁無內容。您可以檢查其他頁面。",
    "column_image": "圖片",
    "column_details": "詳情",
    "order_label": "訂單：",
    "total_label": "總計：",
    "type_label": "類型：",
    "status_label": "狀態：",
    "time_label": "時間：",
    "style_label": "款式：",
    "quantity_prefix": "x",
    "no_remark": "無備註",
    "package_info_label": "包裹資訊",
    "weight_label": "重量：",
    "length_label": "長度：",
    "width_label": "寬度：",
    "height_label": "高度：",
    "unit_kg": "公斤",
    "unit_cm": "厘米",
    "action_label": "操作",
    "view": "查看",
    "photos": "照片",
    "cancel": "取消",
    "mobile_label_total": "總計：",
    "mobile_label_type": "類型：",
    "mobile_label_name": "名稱：",
    "view_product": "查看產品",
    "mobile_style_label": "款式：",
    "no_items_selected": "未選擇任何項目",
    "submit_packaging_request": "提交打包請求",
    "dialog_request_packaging_title": "打包請求",
    "dialog_request_packaging_info": "我們將把您選擇的物品一起打包。打包後，您可以在「我的包裹」中查看實際尺寸並選擇運輸選項。",
    "packaging_instructions": "打包說明",
    "placeholder_packaging_instructions": "有特殊的打包說明或疑慮嗎？",
    "selected_items": "已選項目",
    "packaging_note": "注意：打包後，我們將確定您的包裹的確切尺寸和重量。然後您可以在「我的包裹」部分選擇您的運輸方式並提供您的地址。",
    "new_packaging_process": "新的打包流程",
    "step_request_packaging": "請求打包：",
    "step_request_packaging_desc": "選擇產品並提交打包請求。",
    "step_warehouse_packaging": "倉庫打包：",
    "step_warehouse_packaging_desc": "我們的工作人員將打包您選擇的物品。",
    "step_measurement": "測量：",
    "step_measurement_desc": "我們將測量您包裹的確切尺寸和重量。",
    "step_notification": "通知：",
    "step_notification_desc": "當您的包裹準備好時，您會收到通知。",
    "step_shipping_setup": "運送設置：",
    "step_shipping_setup_desc": "前往「我的包裹」選擇運輸選項並輸入您的地址。",
    "step_make_payment": "付款：",
    "step_make_payment_desc": "根據包裹的實際尺寸和重量支付運費。",
    "confirm_packaging_title": "確認打包請求",
    "confirm_packaging_text": "您即將請求打包 {count} 個項目。是否繼續？",
    "item_qc_photos": "項目QC照片",
    "empty_qc_desc": "您的商品尚未到達我們的倉庫。",
    "return_items_title": "退回商品",
    "return_items_text": "退回商品可能會產生額外費用。您確定要繼續嗎？",
    "number_of_items_to_return": "要退回的商品數量：",
    "confirm": "確認"
  },
  "page_address_book": {
    "title": "我的地址簿",
    "buttons": {
      "add_new": "新增",
      "save": "保存地址"
    },
    "dialog": {
      "title": "新增您的地址",
      "alert": "新增您的地址，以便下次使用！",
      "form": {
        "contact_name": "聯繫人姓名",
        "address": "地址",
        "city": "城市",
        "province": "州/省",
        "country": "國家",
        "country_placeholder": "選擇目的地國家",
        "zip_code": "郵政編碼",
        "phone": "電話",
        "email": "電子郵件",
        "email_placeholder": "推薦"
      }
    }
  },
  "page_wallet": {
    "header": {
      "title": "錢包總覽",
      "subtitle": "管理您的餘額和交易歷史"
    },
    "balance_card": {
      "label": "可用餘額",
      "currency": "美元",
      "top_up_button": "儲值餘額"
    },
    "history": {
      "title": "交易歷史",
      "count": "{count} 筆交易",
      "empty": {
        "title": "暫無交易",
        "subtitle": "您的交易歷史將顯示在此處"
      },
      "item": {
        "order_prefix": "訂單：",
        "balance_after_prefix": "餘額：",
        "note_prefix": "備註：",
        "complete_payment_button": "完成付款",
        "mobile": {
          "order_id_label": "訂單ID：",
          "balance_after_label": "事後餘額：",
          "status_label": "狀態："
        }
      }
    },
    "top_up_dialog": {
      "title": "儲值",
      "form": {
        "amount_label": "輸入金額（美元）",
        "quick_select_title": "快速選擇金額",
        "create_payment_button": "創建付款"
      }
    }
  },
  "page_message_center": {
    "title": "訊息中心",
    "filters": {
      "all": "全部",
      "unread": "未讀",
      "read": "已讀",
      "search_placeholder": "搜索訊息..."
    },
    "actions": {
      "mark_all_read": "全部標為已讀",
      "delete_all": "刪除所有訊息",
      "refresh": "刷新訊息"
    },
    "delete_confirm": {
      "title": "刪除此訊息？",
      "confirm_button": "刪除",
      "cancel_button": "取消"
    },
    "empty_states": {
      "no_search_results": "找不到符合您搜索條件的訊息。",
      "no_unread": "您沒有未讀訊息。",
      "no_read": "您沒有已讀訊息。",
      "no_messages_yet": "您的訊息中心是空的。"
    }
  },
  "page_user_profile": {
    "tabs": {
      "profile": "個人資料",
      "account_safety": "帳戶安全"
    },
    "profile_section": {
      "email": "電子郵件：",
      "gender": "性別：",
      "country": "國家：",
      "language": "語言：",
      "current_language": "英語",
      "phone": "電話：",
      "birthday": "生日：",
      "vip_prefix": "VIP",
      "max_vip_level": "VIP5",
      "privilege_title": "我的特權",
      "privilege_table_header": "等級特權"
    },
    "safety_section": {
      "modify_password_title": "修改密碼",
      "modify_password_desc": "更高級別的密碼使您的帳戶更安全。建議定期更改密碼，包含數字和字母。",
      "modify_password_button": "修改密碼"
    },
    "update_info_dialog": {
      "title": "更新帳戶資訊",
      "account_name_label": "帳戶名稱",
      "phone_label": "電話號碼",
      "gender_label": "性別",
      "gender_placeholder": "選擇",
      "country_label": "國家",
      "country_placeholder": "選擇國家",
      "birthday_label": "生日",
      "birthday_placeholder": "選擇",
      "save_button": "保存資訊"
    },
    "update_password_dialog": {
      "title": "更新密碼",
      "old_password_label": "舊密碼",
      "new_password_label": "新密碼",
      "confirm_password_label": "確認密碼",
      "save_button": "保存"
    }
  },
  "page_shipping_calculator": {
    "hero": {
      "title": "您的終極中國購物代理"
    },
    "form_card": {
      "title": "運費估算",
      "subtitle": "在下方輸入您的包裹詳情以獲取精確的運費",
      "country_label": "目的地國家",
      "country_placeholder": "選擇國家",
      "country_search_placeholder": "搜索國家...",
      "no_countries_for_letter": "沒有以 {letter} 開頭的国家。",
      "no_countries_for_search": "找不到符合 \"{query}\" 的國家。",
      "category_label": "產品類別",
      "category_placeholder": "選擇類別",
      "select_main_category_first": "請先選擇一個主類別。",
      "weight_label": "重量 (kg)",
      "length_label": "長度 (cm)",
      "width_label": "寬度 (cm)",
      "height_label": "高度 (cm)",
      "required_label": "必填",
      "optional_label": "（可選）",
      "optional_placeholder": "可選",
      "calculating_button": "計算中...",
      "submit_button": "獲取運費"
    },
    "summary": {
      "title": "運送查詢摘要",
      "sort_by": "排序方式：",
      "sort_price": "價格",
      "sort_time": "運輸時間",
      "destination": "目的地：",
      "weight": "重量：",
      "dimensions": "尺寸：",
      "volume": "體積：",
      "categories": "類別："
    },
    "results": {
      "loading_text": "正在計算可用的運輸選項...",
      "no_options_title": "無可用運輸選項",
      "no_options_desc": "找不到符合所輸入詳情和目的地的有效運輸選項。<br />請檢查所選國家的重量、尺寸和產品類別限制。",
      "initial_state_text": "請輸入所需參數（國家、重量）並點擊「獲取運費」。",
      "all_unavailable_info": "此組合的所有運輸渠道均不可用。詳情見下文。",
      "est_transit_time": "預計運輸時間",
      "volume_weight": "體積重量",
      "billing_weight": "計費重量",
      "view_details_button": "查看詳情",
      "load_more_button": "加載更多（剩餘 {count} 個）",
      "unavailable_channels_title": "不可用運輸渠道 ({count})",
      "not_available_badge": "不可用",
      "reason_prefix": "原因："
    },
    "details_modal": {
      "overview_title": "運送總覽",
      "shipping_fee": "運費",
      "description_title": "服務說明",
      "no_description": "無可用說明。",
      "restrictions_title": "運輸限制",
      "category_restrictions_title": "產品類別限制",
      "legend_can_send": "可寄送",
      "legend_cannot_send": "不可寄送",
      "can_send_subheading": "可寄送：",
      "cannot_send_subheading": "不可寄送：",
      "no_allowed_items": "未列出具體允許的物品（除非受限制，否則假定一般商品可以）",
      "no_prohibited_items": "未列出具體禁止的物品（適用標準承運商禁令）",
      "rules_title": "運輸規則",
      "weight_restriction_title": "重量限制",
      "dimension_restriction_title": "尺寸限制",
      "billing_rules_title": "計費規則",
      "tax_info_title": "稅務資訊",
      "additional_fees_title": "額外費用",
      "no_additional_fees": "未指定（可能適用標準承運商費用）",
      "min_label": "最小：",
      "max_label": "最大：",
      "carrier_limit": "承運商限制",
      "close_button": "關閉"
    }
  },
  "page_shopping_guide": {
    "header": {
      "title": "購物指南",
      "description": "為初學者提供的淘寶、1688、微店和Yupoo購物指南",
      "video_title": "購物流程影片"
    },
    "process": {
      "title": "購物流程",
      "step1": {
        "title": "步驟1：選擇產品",
        "description": "在淘寶網、1688.com、天貓網或微店上找到您想要的產品。"
      },
      "step2": {
        "title": "步驟2：搜索產品",
        "description": "如果您找不到想要的產品，請隨時向我們的24/7客服尋求幫助。將產品連結複製並粘貼到NiuNiuBox網站。如果您正在使用淘寶應用程式，您也可以在淘寶產品詳情頁面上找到產品連結。"
      },
      "step3": {
        "title": "步驟3：選擇尺寸/顏色",
        "description": "在NiuNiuBox上確認您需要的產品尺寸和顏色，然後將其加入您的購物車。"
      },
      "step4": {
        "title": "步驟4：首次付款",
        "description": "查看您的購物車並完成您所選商品的首次付款。"
      },
      "step5": {
        "title": "步驟5：提交您的地址",
        "description": "完成首次付款後，NiuNiuBox團隊將為您購買產品。在您所有的產品到達我們的倉庫後，您需要提交您的地址，以便我們將您的物品打包成一個大箱子。"
      },
      "step6": {
        "title": "步驟6：二次付款",
        "description": "我們打包好您的產品後，您將收到一封包含包裹重量和運費的電子郵件。然後您需要支付國際運費，我們將從我們的中國倉庫將您的包裹運送到您的地址。"
      },
      "step7": {
        "title": "步驟7：等待您的包裹",
        "description": "您的包裹寄出後，您將在3天內收到一個追踪號碼。這將使您能夠查看您包裹的位置。"
      }
    }
  },
  "page_contact_us": {
    "title": "聯繫我們",
    "support_email_label": "客戶支援電子郵件："
  },
  "page_my_account": {
    "title": "我的帳戶",
    "profile_card": {
      "member_type": "普通會員",
      "member_since": "會員始於",
      "logout_confirm": "您確定要登出嗎？",
      "top_up_button": "儲值",
      "orders_label": "訂單",
      "coupons_label": "優惠券"
    },
    "balance_info": {
      "title": "關於您的餘額",
      "description": "當您請求取消訂單時，您剩餘的資金將自動轉入您的餘額。",
      "highlight1": "用您的餘額繼續購物",
      "highlight2": "聯繫客服退款至您的支付帳戶"
    },
    "quick_actions": {
      "title": "快速操作",
      "shopping_orders": "購物訂單",
      "in_warehouse": "在倉庫",
      "my_rehearsal": "我的排練",
      "my_parcels": "我的包裹",
      "my_balance": "我的餘額",
      "messages": "訊息",
      "my_coupons": "我的優惠券",
      "cancel_order": "取消訂單"
    },
    "recent_orders": {
      "title": "最近訂單",
      "view_all_button": "查看全部",
      "header_product": "產品",
      "header_amount": "金額",
      "header_date": "日期",
      "header_status": "狀態",
      "header_actions": "操作",
      "quantity_prefix": "數量：",
      "details_button": "詳情"
    },
    "invitation": {
      "title": "邀請朋友",
      "description": "與朋友分享我們的網站並賺取獎勵：",
      "copy_button": "複製"
    }
  },
  "page_shopping_order": {
    "title": "購物訂單",
    "search": {
      "order_number_placeholder": "訂單號碼",
      "product_name_placeholder": "產品名稱",
      "status_placeholder": "請選擇",
      "remark_placeholder": "備註",
      "style_sku_placeholder": "款式/SKU",
      "start_date_placeholder": "開始日期",
      "end_date_placeholder": "結束日期",
      "search_button": "搜索",
      "pay_button": "支付購物訂單"
    },
    "info_alert": "此頁面顯示淘寶/1688/微店等購物訂單。請選擇[待付款]訂單並支付。",
    "table": {
      "empty_text": "您還沒有任何購物訂單",
      "header": {
        "image": "圖片",
        "details": "詳情",
        "product": "產品",
        "action": "操作"
      },
      "body": {
        "order_prefix": "訂單：",
        "total_prefix": "總計：",
        "type_prefix": "類型：",
        "status_prefix": "狀態：",
        "time_prefix": "時間：",
        "style_prefix": "款式：",
        "quantity_prefix": "數量：",
        "remark_prefix": "備註：",
        "name_prefix": "名稱："
      },
      "actions": {
        "pay_order": "支付訂單",
        "view_order": "查看訂單",
        "item_photos": "商品照片",
        "cancel_item": "取消商品",
        "view_product": "查看產品"
      }
    },
    "qc_dialog": {
      "title": "商品QC照片",
      "empty_text": "您的商品尚未到達我們的倉庫。"
    },
    "return_dialog": {
      "title": "退回商品",
      "confirmation_text": "退回商品可能會產生額外費用。您確定要繼續嗎？",
      "quantity_label": "要退回的商品數量：",
      "cancel_button": "取消",
      "confirm_button": "確認"
    },
    "cancel_dialog": {
      "title": "取消訂單",
      "confirmation_text": "如果您想取消此訂單，您需要支付運費。費用將從您已支付的款項中扣除。您要繼續嗎？",
      "cancel_button": "取消",
      "confirm_button": "確認"
    }
  },
  "page_shipping_config": {
    "title": "運送配置",
    "summary": {
      "destination": "目的地：",
      "actual_weight": "包裹實際重量：",
      "est_dimensions": "預估尺寸：",
      "weight_note": "*包裹預估重量基於產品重量，實際重量將在稱重後確定。",
      "product_types": "產品類型",
      "selected_method": "已選運輸方式：",
      "selected_method_none": "無",
      "est_fee": "預估費用："
    },
    "status": {
      "loading": "正在計算可用的運輸選項...",
      "no_options": "對於當前的包裹重量、尺寸、產品類型和國家/地區，沒有可用的運輸選項。<br />請檢查限制。"
    },
    "options": {
      "select_sr_label": "選擇 {channelName}",
      "shipping_fee": "運費",
      "volume_weight": "體積重量",
      "volume_weight_formula": "體積重量 (KG) = 長*寬*高 (CM) / {denominator}",
      "billing_weight": "計費重量",
      "billing_weight_details": "基於實際重量（{weight} kg）和體積重量中的較大者。可能會根據渠道規則適用四捨五入和最低收費。",
      "transit_time": "運輸時間",
      "hide_details_button": "隱藏詳情",
      "show_details_button": "顯示詳情"
    },
    "details": {
      "category_restrictions_title": "產品類別限制",
      "legend_can_send": "可寄送",
      "legend_cannot_send": "不可寄送",
      "can_send_subheading": "可寄送：",
      "no_allowed_items": "未列出具體允許的物品（除非受限制，否則假定一般商品可以）",
      "cannot_send_subheading": "不可寄送：",
      "no_prohibited_items": "未列出具體禁止的物品（適用標準承運商禁令）",
      "rules_title": "運輸規則",
      "weight_restriction_title": "重量限制",
      "min_label": "最小：",
      "max_label": "最大：",
      "carrier_limit": "承運商限制",
      "dimension_restriction_title": "尺寸限制",
      "billing_rules_title": "計費規則",
      "tax_info_title": "稅務資訊",
      "additional_fees_title": "額外費用",
      "no_additional_fees": "未指定（可能適用標準承運商費用）"
    },
    "confirm_button": "確認"
  },
  "page_parcel_details": {
    "loading": "正在加載包裹詳情...",
    "overview": {
      "title": "包裹總覽",
      "parcel_id": "包裹ID",
      "payment_time": "付款時間",
      "status": "狀態",
      "shipping_cost": "運費",
      "billing_weight": "計費重量",
      "parcel_remark": "包裹備註",
      "your_note": "您的備註"
    },
    "tracking": {
      "title": "追踪資訊",
      "empty_text": "暫無追踪資訊。發貨後約3天您將收到追踪號碼。"
    },
    "items": {
      "title": "產品項目",
      "empty_text": "找不到項目",
      "header_order_image": "訂單/圖片",
      "header_product_details": "產品詳情",
      "header_qc_photos": "QC照片",
      "order_prefix": "訂單：",
      "sku_prefix": "SKU：",
      "quantity_prefix": "數量：",
      "note_prefix": "備註："
    }
  },
  "page_affiliate": {
    "header": {
      "title": "30% 獎金提升",
      "description": "基於新聯盟會員的運費獎金"
    },
    "commission": {
      "title": "我的推廣佣金",
      "invited_users": "已邀請用戶：",
      "new_affiliates": "新聯盟會員：",
      "active_users": "活躍用戶："
    },
    "balance": {
      "title": "我的聯盟餘額",
      "amount_withdrawn": "已提取金額：",
      "withdrawn_button": "提取",
      "withdrawable_title": "可提取",
      "board_earnings_title": "看板創建收益",
      "claim_button": "領取"
    },
    "steps": {
      "step1": "與您的朋友分享邀請碼",
      "step2": "朋友下單並收到包裹",
      "step3": "獲得佣金"
    },
    "promotion_method": {
      "title": "推廣方式",
      "mobile_description": "規則說明 規則說明 規則說明",
      "desktop_description": "您每月收到的佣金將直接轉入您的個人帳戶。",
      "invite_link_label": "邀請連結：",
      "copy_link_button": "複製連結",
      "copy_code_button": "複製邀請碼",
      "download_qr_button": "下載QR碼"
    }
  },
  "page_product_details": {
    "promo_banner": "從中國電商網站購買高性價比的產品，節省更多金錢。從中國全球運送。",
    "stats": {
      "sales": "銷量：",
      "inventory": "庫存："
    },
    "info": {
      "original_link": "原始連結",
      "processing_time": "付款後，我們將在12小時內為您購買。",
      "domestic_shipping": "國內運費",
      "free_shipping": "免運費",
      "shipping_note": "從賣家到我們中國倉庫的本地運費。"
    },
    "options": {
      "quantity": "數量",
      "items_available": "尚有 {count} 件商品",
      "order_remark": "訂單備註：",
      "order_remark_subtitle": "添加任何特殊說明或要求",
      "remark_placeholder": "請給賣家留言，例如顏色、尺寸等。"
    },
    "actions": {
      "shipping_cost_estimate": "運費估算",
      "disclaimer_title": "免責聲明",
      "disclaimer_text": "Niuniubox上顯示的所有可供代購服務的產品均來自第三方購物平台，並非由Niuniubox直接銷售。因此，對於因侵犯知識產權和商品版權而引起的問題，Niuniubox不承擔任何法律責任。",
      "agreement_checkbox": "我已閱讀並同意",
      "buy_now": "立即購買",
      "add_to_cart": "加入購物車",
      "share": "分享"
    },
    "share_dialog": {
      "title": "分享此產品",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "微信",
      "platform_discord": "Discord",
      "platform_email": "電子郵件",
      "copy_button": "複製"
    },
    "sidebar": {
      "original_site": "原始網站：",
      "why_title": "為什麼選擇淘寶、1688、微店、Yupoo、天貓？",
      "why_description": "這些平台上的產品非常便宜。如果您需要花最少的錢購買高質量的產品，從這些平台購買是最具成本效益的。我們提供空運和海運的全球物流服務。",
      "details_title": "產品詳情",
      "empty_details": "產品詳情為空。"
    },
    "loading": {
      "try_again": "再試一次",
      "note_title": "注意：",
      "error_note_1": "1. 如果您看不到產品信息，可以聯繫我們。",
      "error_note_2": "2. 產品已售罄或產品URL無效。請仔細檢查您的產品連結。",
      "error_note_3": "3. 平台支援：淘寶網、1688.com、天貓網、微店網（僅支援產品URL）"
    }
  },
  "page_product_details": {
    "promo_banner": "從中國電商網站購買高性價比的產品，節省更多金錢。從中國全球運送。",
    "stats": {
      "sales": "銷量：",
      "inventory": "庫存："
    },
    "info": {
      "original_link": "原始連結",
      "processing_time": "付款後，我們將在12小時內為您購買。",
      "domestic_shipping": "國內運費",
      "free_shipping": "免運費",
      "shipping_note": "從賣家到我們中國倉庫的本地運費。"
    },
    "options": {
      "quantity": "數量",
      "items_available": "尚有 {count} 件商品",
      "order_remark": "訂單備註：",
      "order_remark_subtitle": "添加任何特殊說明或要求",
      "remark_placeholder": "請給賣家留言，例如顏色、尺寸等。"
    },
    "actions": {
      "shipping_cost_estimate": "運費估算",
      "disclaimer_title": "免責聲明",
      "disclaimer_text": "Niuniubox上顯示的所有可供代購服務的產品均來自第三方購物平台，並非由Niuniubox直接銷售。因此，對於因侵犯知識產權和商品版權而引起的問題，Niuniubox不承擔任何法律責任。",
      "agreement_checkbox": "我已閱讀並同意",
      "buy_now": "立即購買",
      "add_to_cart": "加入購物車",
      "share": "分享"
    },
    "share_dialog": {
      "title": "分享此產品",
      "platform_facebook": "Facebook",
      "platform_whatsapp": "WhatsApp",
      "platform_wechat": "微信",
      "platform_discord": "Discord",
      "platform_email": "電子郵件",
      "copy_button": "複製"
    },
    "sidebar": {
      "original_site": "原始網站：",
      "why_title": "為什麼選擇淘寶、1688、微店、Yupoo、天貓？",
      "why_description": "這些平台上的產品非常便宜。如果您需要花最少的錢購買高品質的產品，從這些平台購買是最具成本效益的。我們提供空運和海運的全球物流服務。",
      "details_title": "產品詳情",
      "empty_details": "產品詳情為空。"
    },
    "loading": {
      "try_again": "再試一次",
      "note_title": "注意：",
      "error_note_1": "1. 如果您看不到產品信息，可以聯繫我們。",
      "error_note_2": "2. 產品已售罄或產品URL無效。請仔細檢查您的產品連結。",
      "error_note_3": "3. 平台支援：淘寶網、1688.com、天貓網、微店網（僅支援產品URL）"
    }
  },
  "shopping_steps": {
    "title": "運作方式",
    "steps_data": [
      {
        "title": "尋找產品",
        "des": "以批發價瀏覽來自淘寶、1688、微店、天貓等中國市場的數百萬種產品"
      },
      {
        "title": "加入購物車",
        "des": "選擇您的商品，挑選規格，並將它們加入您的購物車以便輕鬆管理訂單"
      },
      {
        "title": "進行付款",
        "des": "安全地為您的商品付款，我們將代表您從不同的賣家處購買"
      },
      {
        "title": "收取包裹",
        "des": "我們將您合併的包裹從中國運送到您家門口，並提供完整的追踪資訊"
      }
    ]
  }
}